import { ConfigProvider, Divider, Flex, Space } from 'antd'
import { createStyles } from 'antd-style'

import { BoldButton } from '@eastcoal/editor/components/BoldButton'
import { BulletListButton } from '@eastcoal/editor/components/BulletListButton'
import { ClearFormatButton } from '@eastcoal/editor/components/ClearFormatButton'
import { FontBackgroundColorButton } from '@eastcoal/editor/components/FontBackgroundColorButton'
import { FontColorButton } from '@eastcoal/editor/components/FontColorButton'
import { FormatPainterButton } from '@eastcoal/editor/components/FormatPainterButton'
import { ItalicButton } from '@eastcoal/editor/components/ItalicButton'
import { LineHeightDropdown } from '@eastcoal/editor/components/LineHeightDropdown'
import { NumberedListButton } from '@eastcoal/editor/components/NumberedListButton'
import { RedoButton } from '@eastcoal/editor/components/RedoButton'
import { StrikethroughButton } from '@eastcoal/editor/components/StrikethroughButton'
import { SuperSubDropdown } from '@eastcoal/editor/components/SuperSubDropdown'
import { TextAlignDropdown } from '@eastcoal/editor/components/TextAlignDropdown'
import { UnderlineButton } from '@eastcoal/editor/components/UnderlineButton'
import { UndoButton } from '@eastcoal/editor/components/UndoButton'

import { BlockTypeSelect } from '../components/BlockTypeSelect'
import { FontFamilySelect } from '../components/FontFamilySelect'
import { FontSizeSelect } from '../components/FontSizeSelect'
import { ImageButton } from '../components/ImageButton'
import { TableButton } from '../components/TableButton'

const useStyles = createStyles(({ token }) => ({
  toolbar: {
    display: 'flex',
    alignItems: 'stretch',
    width: 'fit-content',
    marginInline: 'auto',
    paddingBlock: token.paddingSM
  },
  divider: {
    height: '100%'
  }
}))

const groups = [
  [
    [<UndoButton key='undo' />, <RedoButton key='redo' />],
    [
      <FormatPainterButton key='format-painter' />,
      <ClearFormatButton key='clear-format' />
    ]
  ],
  [
    [
      <BlockTypeSelect key='block-type' />,
      <FontFamilySelect key='font-family' />,
      <FontSizeSelect key='font-size' />
    ],
    [
      <BoldButton key='bold' />,
      <ItalicButton key='italic' />,
      <UnderlineButton key='underline' />,
      <StrikethroughButton key='strikethrough' />,
      <FontColorButton key='font-color' />,
      <FontBackgroundColorButton key='font-background-color' />,
      <SuperSubDropdown key='super-sub' />
    ]
  ],
  [
    [
      <TextAlignDropdown key='text-align' />,
      <LineHeightDropdown key='line-height' />
    ],
    [
      <NumberedListButton key='numbered-list' iconSize={16} />,
      <BulletListButton key='bullet-list' iconSize={16} />
    ]
  ],
  [[<ImageButton key='image' />, <TableButton key='table' />]]
]

export const Toolbar = () => {
  const { cx, styles } = useStyles()
  return (
    <ConfigProvider componentSize='small'>
      <Space
        className={cx(styles.toolbar, 'contract-designer-toolbar')}
        separator={
          <Divider className={styles.divider} orientation='vertical' />
        }
        styles={{
          item: {
            display: 'flex',
            alignItems: 'center'
          }
        }}
      >
        {groups.map((rows, index) => (
          <Flex
            key={index}
            vertical
            className='contract-designer-toolbar-group'
            gap={8}
          >
            {rows.map((row, index) => (
              <Flex
                key={index}
                className='contract-designer-toolbar-row'
                gap={4}
                justify='space-between'
              >
                {row}
              </Flex>
            ))}
          </Flex>
        ))}
      </Space>
    </ConfigProvider>
  )
}
